module.exports = __webpack_public_path__ + "img/usdc-vault.8ef05ac4.svg";